var numeral = require('numeral')

Ember.Handlebars.registerBoundHelper('number', function(value, options) {
    var format = options.hash.format || '0,0'
    return numeral(value).format(format)
})
